<cache-date></cache-date>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<loading [isLoad]="categoryLoader"></loading>
<div class="row">
	<div style="float:left;" *ngIf="chartType == 'Subject'">
		<button type="button" class="btn btn-secondary" (click)="getStats('', 'categories')" [sextant]="'backButton'">{{ 'adminstat.common.Back' | translate }}</button>
		<button type="button" class="btn btn-secondary" (click)="getDetails('')" [sextant]="'windowButton'">{{ 'adminstat.common.In window' | translate }}</button>
	</div>

	<div style="float:left;" *ngIf="chartType == 'Category'">
		<button type="button" class="btn btn-secondary" (click)="getStats('', 'categories')" [sextant]="'categoriesButton'">{{ 'adminstat.template.show categories' | translate }}</button>
		<button type="button" class="btn btn-secondary" (click)="getStats('', 'subjects')" [sextant]="'subjectsButton'">{{ 'adminstat.template.show subjects' | translate }}</button>
	</div>
	
	<br>
	
	<div class="col-md-12">
		<chart [data]="categoryChart.data" [options]="categoryChart.options" [sextant]="reportType + 'Chart'"></chart>
	</div>
</div>


<br>
<div class="col-md-12" *ngIf="categories.length > 0">
	<span class="button-download-link" (click)="downloadButton()">
		<i class="fa fa-download" aria-hidden="true"></i>
		{{ 'adminstat.mails.mailer.export csv' | translate }}
	</span>
</div>
<br>


<br>
<table class="table" *ngIf="!categoryLoader" [sextant]="reportType + 'Table'">
	<thead>
		<tr>
			<th> {{ 'adminstat.support.accessor.' + chartType | translate }}</th>
			<th>Absolute</th>
			<th>Relative (%)</th>
		</tr>
	</thead>

	<tbody>
		<tr *ngFor="let category of categories; let i = index">
			<td>{{ category }}</td>
			<td>{{ values[i + 1] }}</td>
			<td>{{ (values[i + 1] * 100 / totalCount).toFixed(2) }}</td>
		</tr>
	<tbody>
</table>
